import axios from "axios";
import { API_BASE_URL } from "../config";
import { getAuthToken } from "./authService";
import { asErr } from "../utils/apiHelpers";

/** Params for public mosque evaluation (snake_case per API; identificationId required by backend) */
export interface CreatePublicMosqueEvaluationParams {
    // New anonymous uniqueness fields
  channel: "web" | "mobile";
  identifier: string;

  // requester_name: string;
  // requester_national_id?: string;
  // /** Backend requires this key for validation */
  // identificationId?: string;
  // requester_email?: string;
  // requester_mobile_number?: string;
  // requester_date_of_birth?: string;
  mosque_id: number;
  //country?: string;
  imam_muezzin_status?: string;
  staff_commitment?: string;
  prayer_hall_cleanliness?: string;
  restroom_cleanliness?: string;
  basic_supplies_availability?: string;
  notes?: string;
  data_source?: string;
  /** للخادم: تمييز طلب من حساب شريك (ليتجنب رفض التحقق من NIC إن دعمه) */
  request_source?: "donor" | "partner";
}

/** JSON-RPC request body for POST /api/public/mosque/evaluation/create */
interface CreatePublicMosqueEvaluationJsonRpcRequest {
  jsonrpc: string;
  method: string;
  params: CreatePublicMosqueEvaluationParams;
}

/** JSON-RPC error from backend */
interface JsonRpcError {
  code?: number;
  message?: string;
  data?: unknown;
}

/** Success response (adjust if your API returns a specific result shape) */
interface CreatePublicMosqueEvaluationJsonRpcResponse {
  jsonrpc?: string;
  id?: string | number | null;
  result?: unknown;
  error?: JsonRpcError | null;
}

const getBaseURL = () => {
  if (process.env.NODE_ENV === "development") return "";
  return API_BASE_URL;
};

const http = axios.create({
  baseURL: getBaseURL(),
  headers: { Accept: "application/json", "Content-Type": "application/json" },
  timeout: 60000,
});

http.interceptors.request.use((config) => {
  const tok = getAuthToken();
  if (tok) (config.headers as any).Authorization = `Bearer ${tok}`;
  return config;
});

/**
 * POST /api/public/mosque/evaluation/create
 * Sends a public mosque evaluation (JSON-RPC). No auth required.
 */
export async function createPublicMosqueEvaluation(
  params: CreatePublicMosqueEvaluationParams
): Promise<CreatePublicMosqueEvaluationJsonRpcResponse> {
  const body: CreatePublicMosqueEvaluationJsonRpcRequest = {
    jsonrpc: "2.0",
    method: "create",
    params,
  };
  try {
    const { data } = await http.post<CreatePublicMosqueEvaluationJsonRpcResponse>(
      "/api/public/mosque/evaluation/create",
      body
    );
    return data ?? {};
  } catch (e) {
    if (axios.isAxiosError(e) && e.response?.data) {
      const d = e.response.data as any;
      const msg = d?.error?.message ?? d?.detail ?? d?.title;
      if (typeof msg === "string" && msg) throw new Error(msg);
    }
    throw asErr("إرسال التقييم فشل", e);
  }
}
